module.exports = __webpack_public_path__ + "img/gun.672ead61.svg";